"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("./config");
const muiXTelemetrySettings = {
  enableDebug: () => {
    (0, _config.setTelemetryEnvConfigValue)('DEBUG', true);
  },
  enableTelemetry: () => {
    (0, _config.setTelemetryEnvConfigValue)('IS_COLLECTING', true);
  },
  disableTelemetry: () => {
    (0, _config.setTelemetryEnvConfigValue)('IS_COLLECTING', false);
  }
};
var _default = exports.default = muiXTelemetrySettings;